export default __webpack_public_path__ + "static/06-4dea61da356f285db4c1a8d70cdcee0c.png";